// extracted by mini-css-extract-plugin
module.exports = {"root":"tags-module__root___1nXnO","tag":"tags-module__tag___1RGgT"};